import React from 'react';
import {UploadDataPoint} from "../_section/DataPointForm";

function DataForm({upload, inExtWindow, setMortgage}) {

    return (
        <>
            <UploadDataPoint setMortgage={setMortgage} name="iban" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="startDate" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="endDate" upload={upload} inExtWindow={inExtWindow}/>
        </>
    );


}


export default DataForm;